const Counties = [
    {
        name: "Butler-NE",
        displayName: "Butler Northeast",
        coords: [[134,255],[134,277],[157,277],[157,255],[135,255]],
        shape: "poly",
        id: 1
    },
    {
        name: "Butler-SE",
        displayName: "Butler Southeast",
        coords: [[134,277],[134,300],[157,300],[157,277]],
        shape: "poly",
        id: 2
    },
    {
        name: "Butler-SW",
        displayName: "Butler Southwest",
        coords: [
            [111,277],[111,283],[112,282],[114,282],[114,283],[113,284],[113,286],[111,286],[111,300],[134,300],[134,277],
            [111,277]
        ],
        shape: "poly",
        id: 3
    },
    {
        name: "Butler-NW",
        displayName: "Butler Northwest",
        coords: [[111,255],[111,277],[134,277],[134,255],[111,255]],
        shape: "poly",
        id: 4
    },
    {
        name: "Chase-NE",
        displayName: "Chase Northeast",
        coords: [[152,223],[152,239],[170,239],[170,223],[152,223]],
        shape: "poly",
        id: 5
    },
    {
        name: "Chase-SE",
        displayName: "Chase Southeast",
        coords: [[152,239],[152,255],[169,255],[169,246],[170,246],[170,246],[170,239],[152,239]],
        shape: "poly",
        id: 6
    },
    {
        name: "Chase-SW",
        displayName: "Chase Southwest",
        coords: [[134,239],[134,255],[152,255],[152,239],[134,239]],
        shape: "poly",
        id: 7
    },
    {
        name: "Chase-NW",
        displayName: "Chase Northwest",
        coords: [[135,223],[152,223],[152,239],[134,239],[134,236],[135,236],[135,223]],
        shape: "poly",
        id: 8
    },
    {
        name: "Chautauqua",
        displayName: "Chautauqua",
        coords: [[157,313],[157,335],[198,335],[198,313],[157,313]],
        shape: "poly",
        id: 9
    },
    {
        name: "Coffey-N",
        displayName: "Coffey North",
        coords: [[199,229],[199,242],[232,242],[232,229],[199,229]],
        shape: "poly",
        id: 10
    },
    {
        name: "Coffey-S",
        displayName: "Coffey South",
        coords: [[199,242],[199,258],[231,258],[231,242],[199,242]],
        shape: "poly",
        id: 11
    },
    {
        name: "Cowley-E",
        displayName: "Cowley East",
        coords: [[134,300],[134,335],[157,335],[157,300],[134,300]],
        shape: "poly",
        id: 12
    },
    {
        name: "Cowley-W",
        displayName: "Cowley West",
        coords: [[111,300],[111,335],[134,335],[134,300],[111,300]],
        shape: "poly",
        id: 13
    },
    {
        name: "Elk",
        displayName: "Elk",
        coords: [[157,290],[157,313],[198,313],[198,306],[199,306],[199,290],[157,290]],
        shape: "poly",
        id: 14
    },
    {
        name: "Geary",
        displayName: "Geary",
        coords: [
            [125,171],[133,171],[133,177],[135,177],[133,180],[133,181],[144,181],[144,182],[159,182],[159,197],[128,197],
            [128,189],[125,189],[125,171]
        ],
        shape: "poly",
        id: 15
    },
    {
        name: "Greenwood-NE",
        displayName: "Greenwood Northeast",
        coords: [[179,249],[179,269],[199,269],[199,249],[179,249]],
        shape: "poly",
        id: 16
    },
    {
        name: "Greenwood-SE",
        displayName: "Greenwood Southeast",
        coords: [[179,269],[179,290],[199,290],[199,269],[179,269]],
        shape: "poly",
        id: 17
    },
    {
        name: "Greenwood-SW",
        displayName: "Greenwood Southwest",
        coords: [[157,269],[157,290],[179,290],[179,269],[157,269]],
        shape: "poly",
        id: 18
    },
    {
        name: "Greenwood-NW",
        displayName: "Greenwood Northwest",
        coords: [[157,255],[157,269],[179,269],[179,249],[176,249],[176,248],[172,248],[171,249],[169,249],[169,255],[157,255]],
        shape: "poly",
        id: 19
    },
    {
        name: "Johnson",
        displayName: "Johnson",
        coords: [
            [265,189],[265,207],[298,207],[298,200],[296,199],[292,199],[291,198],[286,199],[283,199],[283,197],[280,197],
            [278,196],[278,195],[279,195],[280,194],[283,194],[284,192],[285,194],[287,194],[287,191],[286,190],[286,188],
            [284,188],[283,187],[279,187],[278,185],[277,186],[276,189],[274,188],[273,189],[271,189],[270,188],[268,188],
            [267,189],[265,189]
        ],
        shape: "poly",
        id: 42
    },
    {
        name: "Kay",
        displayName: "Kay",
        coords: [
            [88,335],[88,365],[118,365],[118,361],[117,360],[117,358],[118,357],[122,357],[123,358],[127,358],[130,353],
            [132,353],[133,354],[135,354],[138,351],[140,351],[140,339],[141,339],[141,335],[88,335]
        ],
        shape: "poly",
        id: 21
    },
    {
        name: "Lyon-N",
        displayName: "Lyon North",
        coords: [[170,207],[170,229],[199,229],[199,210],[200,210],[200,207],[170,207]],
        shape: "poly",
        id: 20
    },
    {
        name: "Lyon-S",
        displayName: "Lyon South",
        coords: [
            [170,229],[170,246],[169,246],[169,249],[171,249],[172,248],[179,248],[179,249],[199,249],[199,229], [170,229]
        ],
        shape: "poly",
        id: 22
    },
    {
        name: "Marion",
        displayName: "Marion",
        coords: [[95,216],[127,216],[127,223],[135,223],[135,236],[134,236],[134,255],[111,255],[111,248],[95,248],[95,216]],
        shape: "poly",
        id: 23
    },
    {
        name: "Morris-N",
        displayName: "Morris North",
        coords: [[130,197],[130,201],[127,201],[127,210],[170,210],[170,207],[167,207],[167,200],[159,200],[159,197],[130,197]],
        shape: "poly",
        id: 24
    },
    {
        name: "Morris-S",
        displayName: "Morris South",
        coords: [[127,210],[127,223],[170,223],[170,210],[127,210]],
        shape: "poly",
        id: 25
    },
    {
        name: "Osage-N",
        displayName: "Osage Kansas North",
        coords: [
            [200,197],[200,210],[199,210],[199,213],[232,213],[232,209],[233,209],[233,197],[200,197],
        ],
        shape: "poly",
        id: 27
    },
    {
        name: "Osage-S",
        displayName: "Osage Kansas South",
        coords: [[199,213],[199,229],[232,229],[232,213],[199,213]],
        shape: "poly",
        id: 28
    },
    {
        name: "Osage-Oklahoma-N",
        displayName: "Osage Oklahoma North",
        coords: [
            [141,335],[196,335],[196,361],[118,361],[117,360],[117,358],[118,357],[122,357],[123,358],[127,358],[130,353],
            [132,353],[133,354],[135,354],[138,351],[140,351],[140,339],[141,339],[141,335]
        ],
        shape: "poly",
        id: 29
    },
    {
        name: "Osage-Oklahoma-S",
        displayName: "Osage Oklahoma South",
        coords: [
            [119,365],[119,361],[196,361],[196,397],[176,397],[178,393],[177,392],[171,392],[164,387],[163,387],[163,384],
            [160,384],[158,387],[156,387],[155,386],[154,386],[154,383],[158,381],[156,379],[154,381],[152,381],[149,377],
            [144,377],[143,375],[144,373],[141,367],[138,367],[136,368],[132,374],[128,374],[128,375],[124,375],[121,371],
            [123,369],[126,369],[126,368],[130,368],[130,365],[129,364],[127,364],[127,365],[119,365]
        ],
        shape: "poly",
        id: 30
    },
    {
        name: "Pottawatomie-E",
        displayName: "Pottawatomie East",
        coords: [
            [170,146],[193,146],[193,178],[190,174],[190,173],[187,173],[187,174],[185,173],[183,172],[181,172],[181,173],
            [179,173],[179,172],[178,172],[178,173],[177,173],[177,174],[175,174],[174,173],[172,173],[172,176],[170,176],
            [170,146]
        ],
        shape: "poly",
        id: 31
    },
    {
        name: "Pottawatomie-W",
        displayName: "Pottawatomie West",
        coords: [
            [152,148],[149,148],[148,149],[148,151],[147,151],[147,152],[145,152],
            [145,154],[143,154],[142,156],[142,158],[145,161],[150,168],[152,168],[152,170],[155,170],[155,174],[158,174],
            [158,175],[162,175],[162,175],[162,174],[167,174],[167,176],[170,176],[170,146],[153,146]
        ],
        shape: "poly",
        id: 32
    },
    {
        name: "Riley",
        displayName: "Riley",
        coords: [
            [125,146],[153,146],[153,147],[152,147],[152,148],[149,148],[148,149],[148,151],[147,151],[147,152],[145,152],
            [145,154],[143,154],[142,156],[142,158],[145,161],[150,168],[152,168],[152,170],[155,170],[155,174],[158,174],
            [158,175],[162,175],[162,174],[167,174],[167,184],[159,184],[159,182],[144,182],[144,181],[142,181],[142,182],
            [141,182],[141,181],[133,181],[133,180],[135,178],[135,177],[133,177],[133,171],[125,171],[125,146]
        ],
        shape: "poly",
        id: 33
    },
    {
        name: "Sedgwick",
        displayName: "Sedgwick",
        coords: [
            [111,283],[111,268],[70,268],[70,274],[71,274],[71,281],[63,281],[63,300],[111,300],[111,287],[110,287],[110,285],
            [108,285],[108,287],[107,287],[107,286],[105,286],[105,288],[104,288],[104,287],[101,287],[101,290],[105,294],
            [103,297],[99,292],[98,292],[98,296],[96,294],[96,291],[94,291],[91,288],[89,288],[87,286],[83,286],[83,285],
            [85,285],[87,283],[87,280],[88,279],[87,278],[87,277],[88,277],[88,278],[89,279],[91,279],[92,282],[95,282],
            [95,278],[93,274],[95,272],[96,274],[100,275],[104,278],[105,278],[105,281],[107,281],[108,282],[111,283],
            [113,283],[112,285],[111,287]
        ],
        shape: "poly",
        id: 34
    },
    {
        name: "Wabaunsee-NE",
        displayName: "Wabaunsee Northeast",
        coords: [
            [180,173],[181,172],[183,172],[183,174],[187,174],[187,173],[190,173],[191,175],[190,176],[191,177],[193,177],
            [193,178],[194,178],[198,179],[200,180],[200,190],[180,190],[180,184]
        ],
        shape: "poly",
        id: 35
    },
    {
        name: "Wabaunsee-SE",
        displayName: "Wabaunsee Southeast",
        coords: [[180,190],[180,207],[200,207],[200,190],[180,190]],
        shape: "poly",
        id: 36
    },
    {
        name: "Wabaunsee-SW",
        displayName: "Wabaunsee Southwest",
        coords: [[159,190],[159,200],[167,200],[167,207],[180,207],[180,190],[159,190]],
        shape: "poly",
        id: 37
    },
    {
        name: "Wabaunsee-NW",
        displayName: "Wabaunsee Northwest",
        coords: [
            [159,184],[167,184],[167,176],[172,176],[172,173],[174,173],[176,174],[177,174],[178,172],[180,173],
            [180,190],[159,190],[159,184]
        ],
        shape: "poly",
        id: 38
    },
    {
        name: "Nowata",
        displayName: "Washington-Nowata Oklahoma",
        coords: [[196,335],[196,377],[210,377],[210,364],[238,364],[238,339],[239,339],[239,335],[196,335],],
        shape: "poly",
        id: 26
    },
    {
        name: "Wilson",
        displayName: "Wilson",
        coords: [[199,281],[199,306],[216,306],[231,307],[231,281],[199,281]],
        shape: "poly",
        id: 39
    },
    {
        name: "Woodson",
        displayName: "Woodson",
        coords: [[199,258],[199,281],[231,281],[231,258],[199,258]],
        shape: "poly",
        id: 40
    },
    {
        name: "Wyandotte",
        displayName: "Wyandotte",
        coords: [
            [276,185],[276,178],[277,178],[277,173],[285,173],[289,176],[287,177],[281,177],[285,179],[287,183],[287,180],
            [284,185],[281,184], [280,186],[278,184],[276,185]
        ],
        shape: "poly",
        id: 41
    }
];

export default Counties;